import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useOutletContext} from 'react-router-dom';
import {addRevenueFormData} from '../../redux/formReducer';
import revenuDataApi from '../../components/Utilities/apis/revenuDataApi';
import RevenueForm from '../../components/Form/RevenuDataForm';

const RevenuDataComponent = ({handleClose}) => {
	const user = useSelector((state) => state.PowerBi.user);
	const [loadRevenueData, setLoadRevenueData] = useState(false);
	const dispatch = useDispatch();
	const googleIdToken = useOutletContext(); // <-- access context value
	const fetchRevenueData = async () => {
		setLoadRevenueData(true);
		const result = await revenuDataApi([
			googleIdToken,
			user?.EMAILID,
			user?.PBI_ROLE,
		]);
		setLoadRevenueData(false);
		dispatch(addRevenueFormData(result));
	};
	useEffect(() => {
		if (Object.keys(user).length !== 0) {
			setLoadRevenueData(true);
			revenuDataApi([googleIdToken, user?.EMAILID, user?.PBI_ROLE]).then(
				(result) => {
					dispatch(addRevenueFormData(result));
					setLoadRevenueData(false);
				}
			);
		}
	}, [dispatch, googleIdToken, user]);
	return (
		<RevenueForm
			handleClose={handleClose}
			fetchRevenueData={fetchRevenueData}
			loadRevenueData={loadRevenueData}
		/>
	);
};

export default RevenuDataComponent;
